
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 8h-.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H14l-.86 5.16a1 1 0 01-1 .84H3.85a1 1 0 01-1-.84zm6 .5a.5.5 0 00-.5.5v3a.5.5 0 001 0V9a.5.5 0 00-.5-.5zm2 0a.5.5 0 00-.5.5v3a.5.5 0 001 0V9a.5.5 0 00-.5-.5zm-4 0a.5.5 0 00-.5.5v3a.5.5 0 001 0V9a.5.5 0 00-.5-.5zM4 5l3.7-3.38a.51.51 0 01.68 0L12 5h-2L8.38 3.47a.5.5 0 00-.68 0L6.06 5z"}})])
          )
        }
      }
    